import React from 'react';
import {useParams} from 'react-router-dom';
import {useMediaQuery, useTheme} from '@mui/material';

import TopAppBar from '../../common/top-app-bar/TopAppBar';
import WidgetsMenuList from './widgets-menu-list/WidgetsMenuList';
import {DragDropContext} from 'react-beautiful-dnd';

import {
  ContentDiv,
  ContentGrid,
  ContentGridDiv,
  WidgetsHomePageWrapperGrid,
  MainContentDiv,
  MainContentGrid,
  TopAppBarDiv,
  BackgroundGrid
} from './WidgetsHomePageStyles';
import WidgetsViewPage from './widgets-view-page/WidgetsViewPage';
// import DropZone from './widgets-view-page/DropZone';

const WidgetsHomePage = (): React.ReactElement => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const params: any = useParams();
  const [drawer, setDrawer] = React.useState<boolean>(true);

  const [widgetList, setWidgetList]: any = React.useState([]);

  const handleMenuAction = () => {
    setDrawer(!drawer);
  };

  const handleDragEnd = (result: any) => {
    // if (!result.destination) return;

    const newWidgetList = [...widgetList];
    newWidgetList.push(result?.draggableId);
    setWidgetList(newWidgetList);
  };

  return (
    <WidgetsHomePageWrapperGrid container>
      <BackgroundGrid>
        <ContentGrid item>
          <ContentGridDiv>
            <DragDropContext onDragEnd={handleDragEnd}>
              {/* <DropZone> */}
              {!isMobile && (
                <WidgetsMenuList
                  padId={params?.pad_id}
                  drawerOpen={drawer}
                  applicationId={params?.application_id}
                />
              )}
              {/* </DropZone> */}

              <ContentDiv>
                <TopAppBarDiv>
                  <TopAppBar
                    handleMenuAction={() => handleMenuAction()}
                    applicationId={params?.application_id}
                    padId={params?.pad_id}
                    showWidgetsSaveButton={true}
                  />
                </TopAppBarDiv>

                <MainContentDiv>
                  <MainContentGrid item>
                    <WidgetsViewPage
                      applicationId={params?.application_id}
                      padId={params?.pad_id}
                      droppedComponents={widgetList}
                    />
                  </MainContentGrid>
                </MainContentDiv>
              </ContentDiv>
              {/* </DropZone> */}
            </DragDropContext>
          </ContentGridDiv>
        </ContentGrid>
      </BackgroundGrid>
    </WidgetsHomePageWrapperGrid>
  );
};
export default WidgetsHomePage;
